const state = {
	adminUserInfo: "",
	adminUserId:"",     //选中的营养师马甲id
	accountUserId:"",   //登录账号的营养师马甲id，用于聊天的未读信息判断
	token:"",
	
	// 是否需要登录，当掉线时，弹窗通知
	// 黄耿智：2022-12-23
	isNeedLogin:false,
}

const mutations = {
	setAdminUserInfo(state, adminUserInfo) {
		state.adminUserInfo = adminUserInfo || "";
	},
	setAdminUserId(state,adminUserId){
		state.adminUserId = adminUserId || "";
	},
	setAccountUserId(state,accountUserId){
		state.accountUserId = accountUserId || "";
	},
	setToken(state,token){
		state.token = token || ""
	},
	// 是否需要登录，当掉线时，弹窗通知
	// 黄耿智：2022-12-23
	setIsNeedLogin(state,data){
		state.isNeedLogin = data;
	}
}

const actions = {
	setAdminUserInfo({commit},adminUserInfo) {
		// do something async
		commit('setAdminUserInfo',adminUserInfo)
	},
	setAdminUserId({commit},adminUserId){
		commit('setAdminUserId',adminUserId)
	},
	setAccountUserId({commit},accountUserId){
		commit('setAccountUserId',accountUserId)
	},
	setToken({commit},token){
		commit('setToken',token)
	}
}

export default {
	state,
	mutations,
	actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js